export default __webpack_public_path__ + "static/media/word.9581b24b.svg";